import track_list from "../assets/asset_loaders/tracks";

/**
 * Get all available tracks for Mario Kart World for use in filter autocomplete
 */
export function getAllWorldTracks() {
    return track_list.map(track => ({
        id: track.id,
        name: track.name
    }));
}
